export const Theme = {
  typography: {
    fontFamily: ["DMSans-Regular"],
  },
  palette: {
    primary: {
      main: "#005F35",
    },
    secondary: {
      main: "#fef200",
    },
    light: {
      main: "white",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "7px",
          textTransform: "none",
          fontWeight: 600,
          fontSize: "0.8rem",
          boxShadow: "none",
          "&:hover": { boxShadow: "none" },
        },
        containedPrimary: {
          background: "#005F35",
          "&:hover": { background: "#004D2B" },
        },
        outlinedPrimary: {
          borderColor: "#005F35",
          color: "#005F35",
          "&:hover": { background: "#EAF4EE" },
        },
        sizeMedium: { padding: "7px 16px" },
        sizeSmall: { padding: "5px 11px", fontSize: "0.75rem" },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorSuccess: { background: "#ECFDF5", color: "#065F46" },
        colorWarning: { background: "#FFFBEB", color: "#92400E" },
        colorError: { background: "#FEF2F2", color: "#991B1B" },
        colorInfo: { background: "#EFF6FF", color: "#1E40AF" },
        colorDefault: { background: "#F1F5F9", color: "#475569" },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 30,
        },
      },
    },
  },
};
